var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"img-zoomer-box"}},[_c('img',{attrs:{"id":"img-1","src":_vm.imageSelected},on:{"mousemove":_vm.zoomer}}),_c('div',{style:({'background-image': `url(${_vm.imageSelected})`}),attrs:{"id":"img-2"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }